import {
  createCurrencyDictionaryItem,
  MockCurrencyDictionaryItem,
} from '@dapi/sdk/spec';

export const currencyCode = 'EUR';
export const currency: MockCurrencyDictionaryItem = createCurrencyDictionaryItem();
